import { AvailableSlotsNew, Available, ServiceInfoType } from "../booking";
import { formatInTimeZone } from "date-fns-tz";
import { parseISO, getUnixTime, addMinutes } from "date-fns";

export function groupByDayTime(
  slots: AvailableSlotsNew[],
  timeZone: string,
  minimum: number,
  serviceId: string,
  info: ServiceInfoType | null,
) {
  let available: Available[] = [];

  slots.forEach((slot) => {
    const items = slot.available.map((time) => ({
      timeZone: timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
      date: slot!.date,
      id: slot!.id,
      orgTime: time,
      time: formatInTimeZone(
        time,
        timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
        "p",
      ),
      staffId: slot.staffId,
      staffEmail: slot.staffEmail,
      hour: Number(
        formatInTimeZone(
          time,
          timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
          "HH",
        ),
      ),
    }));
    available.push(...items);
  });
  available = available
    .sort((a, b) => a.hour - b.hour)
    .filter(
      (t) =>
        getUnixTime(parseISO(t.orgTime)) >
        getUnixTime(
          addMinutes(
            parseISO(
              formatInTimeZone(new Date(), timeZone, "yyyy-MM-dd HH:mm:ssXXX"),
            ),
            minimum ?? 0,
          ),
        ),
    );

  let morning = available?.filter((t) => t.hour < 12) || [];
  let afternoon = available?.filter((t) => t.hour >= 12 && t.hour < 18) || [];

  let evening = available?.filter((t) => t.hour >= 18) || [];
  if (serviceId) {
    morning = includeSlotsWith(morning, info);
    afternoon = includeSlotsWith(afternoon, info);
    evening = includeSlotsWith(evening, info);
  }

  const data = morning.concat(afternoon).concat(evening);

  return {
    morning,
    afternoon,
    evening,
    isEmpty: data.length === 0,
  };
}

export const includeSlotsWith = (
  source: Available[],
  info: ServiceInfoType | null,
) => {
  const serviceSetting = info?.includedMins?.map((s) =>
    s.length === 1 ? `0${s}` : s,
  );
  if (!serviceSetting) return source;

  const result = source.filter((slot) =>
    serviceSetting.includes(
      formatInTimeZone(parseISO(slot.orgTime), slot.timeZone, "mm"),
    ),
  );
  return result;
};
